<div style="padding: 24px;text-align: center;background: #161616;" class="delete_container">
  <div style="font-size:18px;font-weight:700;color: #dedede;">Delete Document</div>
  <div style="margin-top:8px;margin-bottom:16px;color: #dedede;opacity: 0.7;font-size:14px">Are you sure want to delete
    this document？</div>
  <div style="display: flex; justify-content: center">
    <button mat-button (click)="cancel()" class="cancel_button">Cancel</button>
    <button mat-button (click)="confirm()" class="confirm_button">Confirm</button>
  </div>
</div>